module.exports = __webpack_public_path__ + "static/img/1.e7dcd631.png";